import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// @ts-ignore
import { ButtonWithIcon } from '@els/els-react--button';
import { IRootState } from '../../app/store';
import { popPage } from './back-button-slice';
import { setNavigatingBackToSearch } from '../../features/search/search-slice';
import './back-button.scss';

const BackButton: React.FC = () => {
    const baseClassName = 'back-button';
    const historyStack = useSelector(
        (state: IRootState) => state.navigation.history
    );
    const dispatch = useDispatch();
    const history = useHistory();

    const canGoBack = historyStack.length > 1;
    const previousPage = historyStack[historyStack.length - 2];
    const currentPage = historyStack[historyStack.length - 1];

    const handleBackClick = () => {
        if (canGoBack && previousPage) {
            const isNavigatingFromSkillToSearch =
                (currentPage?.name?.toLowerCase().includes('skill') ||
                    currentPage?.path?.includes('/skill-launch/')) &&
                previousPage?.name === 'Search';
            const isNavigatingFromPatientEducationToSearch =
                (currentPage?.name
                    ?.toLowerCase()
                    .includes('patient education') ||
                    currentPage?.path?.includes('/patient-education')) &&
                previousPage?.name === 'Search';

            dispatch(popPage());

            if (
                isNavigatingFromSkillToSearch ||
                isNavigatingFromPatientEducationToSearch
            ) {
                dispatch(setNavigatingBackToSearch(true));
                history.push({
                    pathname: previousPage.path,
                    state: { navigatedBack: true },
                });
            } else {
                history.push(previousPage.path);
            }
        }
    };

    return (
        <ButtonWithIcon
            className={`${baseClassName}`}
            sprite="ChevronLeft"
            type="link"
            linkIconSize="xs"
            onClick={handleBackClick}
        >
            <span className={`${baseClassName}__text`}>
                {`Back to ${previousPage?.name}`}
            </span>
        </ButtonWithIcon>
    );
};

export default BackButton;
